export default "__VITE_ASSET__BEh5FGKo__"